import './PeriscopeLink.scss';
import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { getSonarObjectTypeSourceLabel } from '@sonar-software/sonar-ts-lib';
import { NewWindowIcon } from './NewWindowIcon';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { useAmplitude } from '@hooks';
import React, { useCallback } from 'react';

function getTitle(sonarObjectType: SonarObjectType): string {
	return `View in ${getSonarObjectTypeSourceLabel(sonarObjectType)}`;
}

export interface PeriscopeSfLinkProps {
	iconColor?: string;
	id?: string;
	sonarObjectType: SonarObjectType;
	url?: string;
}

export const PeriscopeLink: React.FC<PeriscopeSfLinkProps> = ({ iconColor, id, sonarObjectType, url }) => {
	const logAnalyticEvent = useAmplitude();

	const handleClick = useCallback((e: React.MouseEvent<HTMLSpanElement>) => {
		e.stopPropagation();

		logAnalyticEvent({
			data: { objectType: sonarObjectType },
			id: AMPLITUDE_EVENT.SALESFORCE_URL_CLICKED
		});
	}, [ logAnalyticEvent, sonarObjectType ]);

	if (!url) {
		return null;
	}

	const title = getTitle(sonarObjectType);

	return (
		<div className='periscope-link'>
			<a
				href={ url }
				id={ id }
				onClick={ handleClick }
				target='_blank'
				title={ title }>
				<NewWindowIcon
					color={ iconColor }
					title={ title } />
			</a>
		</div>
	);
};
